<div #pageHeader id="pageHeader" class="pageHeader w3-margin">
  <h2>{{ pageheader.pageTitle | translate: router.transparams | customTitleCase }}</h2>
  <div *ngIf="router.transparams.customer_shortname == 'Inholland' && ( pageheader.pageTitle == 'pagetitle.login' || pageheader.pageTitle == 'pagetitle.surfconext')">
    <p>{{ 'login.line1' | translate: router.transparams }}</p>
    <p>{{ 'login.line2' | translate: router.transparams }}</p>
  </div>
  <omnipas-message></omnipas-message>
</div>
